<template>
  <!-- 选择内容的弹出框  -->
  <div>
    <el-dialog title="创建周边推荐"
               class="content-dialog"
               :visible.sync="visible"
               :show="show"
               top="10vh"
               width="80%"
               @opened="openedDialog"
               @close="handleClose">

      <div style="display:flex"
           v-loading='loading'>

        <!-- -------------迹点列表------------- -->

        <div class="traver-add-recommend-area">
          <!-- 输入框 -->
          <div v-if="showInputTitle"
               class="traver-add-recommend-title">
            <el-input v-model="input_recommsnd_title"
                      size="mini"
                      placeholder="请输入推荐名称"></el-input>
            <el-input type="textarea"
                      style="margin-top:10px"
                      :rows='4'
                      resize='none'
                      placeholder="请输入推荐内容"
                      v-model="recommend_text_area">
            </el-input>
          </div>
          <!-- 列表 -->
          <div class="traver-card-check-list">
            <card-One-list :cardList="traver_point_list"
                           :checkedList="band_Traver_list"
                           :showUpdate="false"
                           :showDest="false"
                           :showTag="false"
                           titleMiniName=""
                           @checkedItem="checkedItem"
                           @clickTraverPoint="clickTraverPoint"
                           @loadMorTraverPointer="loadMorTraverPointer"
                           buttonName=""></card-One-list>
          </div>
          <!-- 确认新建按钮 -->
          <div v-if="recommend_id==null"
               style="margin-left:auto;margin-top:10px;text-align:center">
            <el-button @click="creatNewTraverContent"
                       type="primary"
                       style="width:100%"
                       size="mini">新建推荐</el-button>

          </div>
          <!-- 修改 推荐 -->
          <div v-else
               style="margin-left:auto;margin-top:10px;text-align:center">
            <el-button @click="reNewTraverContent"
                       type="primary"
                       style="width:100%"
                       size="mini">修改推荐</el-button>

          </div>

        </div>
        <!-- 地图与筛选 -->
        <div class="content-card-check-map">
          <!-- 筛选区 -->
          <div class="filter-area">
            <!-- 目的地 -->
            <div>
              <select-dest placeholder="所属目的地"
                           :destShowBack='destShowBack'
                           @selectDest="selectDest"></select-dest>
            </div>
            <!-- 搜索 -->
            <el-input size="mini"
                      style="width:50%;margin-left:20px"
                      placeholder="请输入该目的地迹点名称"
                      v-model="searchContentKeyword"
                      clearable>
              <el-button slot="append"
                         @click="searchButton"
                         icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <!-- 地图 -->
          <show-all-location-on-map ref='showLocationOnMap'
                                    :latprop="latprop"
                                    :lngprop="lngprop"
                                    :poiList="traver_point_list"></show-all-location-on-map>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import SelectDest from '../select/SelectDest'
import SelectTag from '../select/SelectTag'
import CardOneList from '../cards/CardOneList'
import ShowAllLocationOnMap from '../../map/ShowAllLocationOnMap'
export default {
  name: 'select-and-search-content',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'card-One-list': CardOneList,
    ShowAllLocationOnMap,
  },
  data() {
    return {
      recommend_id: null,
      loading: false,
      visible: this.show,
      searchContentKeyword: '',
      dest: '',
      traver_point_list: [], //显示的迹点列表
      contentTags: [],
      tag_list: [],
      // 迹点列表
      destShowBack: null,
      // 创建推荐所需的数据
      input_recommsnd_title: this.inputRecommsndTitle, // 推荐标题
      recommend_text_area: this.recommendTextArea, // 推荐介绍
      band_Traver_list: [], // 需要绑定的迹点id
    }
  },
  props: {
    latprop: '',
    lngprop: '',
    showInputTitle: {
      type: Boolean,
      default: true,
    },
    // 推荐名 he介绍
    inputRecommsndTitle: String,
    recommendTextArea: String,
    // 对话框用于传递是否显示
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val
      },
    },
  },
  mounted() {
    // this.$refs.showLocationOnMap.lat = this.lat
    // this.$refs.showLocationOnMap.lng = this.lng
    // this.$refs.showLocationOnMap.pointerOnMap()
    this.getTraverPointFromDest()
    // 获取目的地，再传入目的地
  },
  methods: {
    //  新建 推荐
    creatNewTraverContent() {
      // console.log(this.band_Traver_list)
      // console.log(this.inputRecommsndTitle)
      // console.log(this.recommendTextArea)
      let newrecommend = {
        title: this.input_recommsnd_title,
        introduce: this.recommend_text_area,
        id_list: this.band_Traver_list,
      }
      this.$emit('creatNewTraverContent', newrecommend)
    },
    // 修改周边推荐
    reNewTraverContent() {
      let newrecommend = {
        recommend_id: this.recommend_id,
        title: this.input_recommsnd_title,
        introduce: this.recommend_text_area,
        id_list: this.band_Traver_list,
      }
      this.$emit('reNewTraverContent', newrecommend)
    },
    // 打开对话框时
    openedDialog() {
      this.getTraverPointList(this.dest)
    },
    // 关闭回调
    handleClose() {
      // this.traver_point_list = []
      this.recommend_id = null
      this.input_recommsnd_title = ''
      this.recommend_text_area = ''
      this.band_Traver_list = []
      // console.log('清空迹点选择', this.band_Traver_list)
      this.$emit('update:show', false)
    },
    // 选择内容
    checkedItem(val) {
      this.band_Traver_list = val
    },
    // 点击选择目的地
    selectDest(value) {
      this.dest = value
    },
    // 点击迹点图片，让其剧中显示
    clickTraverPoint(val) {
      // 替换图标
      this.$refs.showLocationOnMap.clickOnPointer(
        val.id,
        parseFloat(val.lat),
        parseFloat(val.lng)
      )
      // this.$refs.showLocationOnMap.init()
      // this.$refs.showLocationOnMap.setMarkerPointerCenter(
      //   val.id,
      //   parseFloat(val.lat),
      //   parseFloat(val.lng)
      // )
    },
    // 点击搜索按钮
    searchButton() {
      this.traver_point_list = []
      this.getTraverPointList(this.dest)
    },
    // 选择标签的回调
    getSelectList() {},
    // 获取 内容 的所有标签【没必要，且不执行】
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 获取 当前迹点的目的地列表
    getTraverPointFromDest() {
      this.loading = true
      this.$http
        .get(
          `/traver/traver_id_get_dest?traver_id=${this.$route.query.traver_id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.dest = res.data.dest
            this.destShowBack = res.data.dest
            this.loading = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取迹点列表[周边推荐用]
    getTraverPointList(dest_id, page) {
      this.loading = true
      if (page == undefined) {
        page = 1
      }
      this.$http
        .get(
          `/traver/get_traver_point_list?source_map=2&traver_title=${this.searchContentKeyword}&dest=${dest_id}&p_size=20&p_num=${page}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            let list = res.data.data
            if (list.length == 0) {
              this.$message({
                message: '无更多数据',
                type: 'error',
              })
              this.loading = false
              return
            }
            list.forEach((i) => {
              if (i.poi_id !== null) {
                let item = {
                  id: i.id,
                  title: i.traver_title,
                  title_mini: i.traver_info,
                  image: i.traver_cover,
                  class_name: i.traver_class,
                  lng: i.poi_lng,
                  lat: i.poi_lat,
                }
                // console.log(item)
                this.traver_point_list.push(item)
                // 执行添加坐标
                this.$refs.showLocationOnMap.pointerOnMap()
                this.loading = false
              }
            })
          }
        })
    },
    // 加载更多
    loadMorTraverPointer(page) {
      this.getTraverPointList(this.dest, page)
    },
  },
}
</script>

<style>
/* .content-dialog .el-dialog__body {
  background-color: red;

} */

.filter-area {
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}
.traver-add-recommend-area {
  width: 30%;
  max-height: 550px;
}
.traver-add-recommend-title {
}
.traver-card-check-list {
  overflow: scroll;
  padding: 5px;
  width: 96%;
  height: 300px;
  margin-top: 10px;
  border: 1px solid rgb(204, 204, 204);
  background-color: rgb(240, 240, 240);
}
.content-card-check-map {
  width: 70%;
  padding-left: 10px;
}
</style>